<template>
  <div>
    <Table
      resource="Question"
      :actions="actions"
      :items="$store.getters['question/tableData']"
      :detail="$store.getters['question/detailData']"
      :fields="$store.getters['question/tableFields']"
      :pagination="$store.state.question.tablePagination"
      :keyword="$store.state.question.tableKeyword"
      :loading="$store.state.question.loadingTable"
      :filter="$store.state.question.tableFilter"
      :sort="$store.state.question.tableSort"
      :sort-options="sortOptions"
      @changeFields="changeFields"
      @resetFields="resetFields"
      @filter="filterData"
      @sort="sortData"
      @load="loadData"
      @delete="deleteData"
      @loadDetail="loadDetail"
      @resetDetail="resetDetail"
      @paginate="paginate"
      @search="search"
    />
  </div>
</template>

<script>
import Table from '@/layouts/components/Table.vue'

export default {
  components: {
    Table,
  },
  data() {
    return {
      // Sort
      sortOptions: [
        {
          key: 'created_at', direction: 'desc', label: 'Terbaru', default: true,
        },
        { key: 'created_at', direction: 'asc', label: 'Terlama' },
      ],

      actions: [
        'create',
        'view',
        'update',
        'delete',
      ],
    }
  },
  methods: {
    loadData() {
      return this.$store.dispatch('question/getTableData')
    },
    loadDetail(id) {
      return this.$store.dispatch('question/getDetail', id)
    },
    deleteData(id, callback) {
      return this.$store.dispatch('question/delete', id)
        .then(callback)
    },
    resetDetail() {
      this.$store.commit('question/SET_DETAIL_DATA', undefined)
    },
    changeFields(val) {
      this.$store.commit('question/SET_TABLE_FIELDS', val)
    },
    resetFields() {
      this.$store.commit('question/RESET_TABLE_FIELDS')
    },
    filterData(val) {
      this.$store.commit('question/SET_TABLE_FILTER', val)
    },
    sortData(val) {
      this.$store.commit('question/SET_TABLE_SORT', val)
    },
    paginate(val) {
      this.$store.commit('question/SET_TABLE_PAGINATION', val)
    },
    search(val) {
      this.$store.commit('question/SET_TABLE_KEYWORD', val)
    },
  },
}
</script>
